import QRCode from 'react-qr-code';
import PropTypes from 'prop-types';
import addToAppleWallet from 'sealink/images/add-to-apple-wallet.svg';

const PassCard = ({ pass }) => (
  <div className="card shadow-none">
    <div className="card-body d-flex align-items-center gap-3 py-2 px-3">
      {pass.reference && <QRCode value={pass.reference} size={80} />}
      <div className="flex-grow-1">
        {pass.consumer_type && (
          <div className="text-muted small">{pass.consumer_type}</div>
        )}
        {pass.consumer_name && (
          <div className="fw-bold">{pass.consumer_name}</div>
        )}
        <a href={pass.apple_wallet_url} className="mt-2 d-inline-block">
          <img src={addToAppleWallet} alt="Add to Apple Wallet" height="35" />
        </a>
      </div>
    </div>
  </div>
);

export const passPropType = PropTypes.shape({
  uid: PropTypes.string.isRequired,
  reference: PropTypes.string,
  consumer_type: PropTypes.string,
  consumer_name: PropTypes.string,
  apple_wallet_url: PropTypes.string.isRequired,
});

PassCard.propTypes = {
  pass: passPropType.isRequired,
};

export default PassCard;
